import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KORISNICKA_PODRSKA_MOBILE, KORISNICKA_PODRSKA_MOBILE_HREF } from "@kodit/core/shared";

@Component({
  selector: 'kodit-access-denied-page',
  templateUrl: './access-denied-page.component.html',
  styleUrls: ['./access-denied-page.component.scss'],
})
export class AccessDeniedPageComponent implements OnInit {
  reason: 'paket' | 'permisija' | null = null;

  constructor(private _route: ActivatedRoute, private _router: Router) {}

  ngOnInit(): void {
    const r = this._route.snapshot.queryParamMap.get('reason');
    if (r === 'paket' || r === 'permisija') {
      this.reason = r;
    }
  }

  goBack(): void {
    window.history.back();
  }

  public readonly KORISNICKA_PODRSKA_MOBILE_HREF = KORISNICKA_PODRSKA_MOBILE_HREF;
  public readonly KORISNICKA_PODRSKA_MOBILE = KORISNICKA_PODRSKA_MOBILE;
}
